<template>
    <div class="content-wrapper position-relative d-flex flex-grow-1">
        <div class="content container-fluid">
            <transition name="page-custom" mode="out-in" :key="$router.currentRoute.fullPath">
                <router-view :key="contentsKey" class="mb-auto h-100"/>
            </transition>
        </div>

    </div>
</template>

<script>

    import { mapGetters } from 'vuex';
    import UIConstants from "../../store/ui/constants";

    export default {
        name: 'Content',
        computed: {
            ...mapGetters(['userId']),
            contentsKey() { return this.$route.path + '-' + this.userId },
        }
    };
</script>

<style lang="scss" scoped>
    .page-custom-enter-active, .page-custom-leave-active {
      transition: opacity 0.3s, transform 0.5s;
    }
    .page-custom-enter, .page-custom-leave-to {
      opacity: 0;
      transform: translateX(-30%);
    }

</style>
